import { ObjectSerialization } from '../../../../serialization/object-serialization';
import { ProviderInstanceApplication } from '../../../provider-instance-application';

export class FileShareCollectedObjectCreateEntity extends ProviderInstanceApplication {
  objectType: number;
  object: ObjectSerialization;
  dataCollectDate: Date;
}
